export default __webpack_public_path__ + "static/media/engineer.fe5e3e03.jpg";